import * as React from "react";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";
import SignInForm, { SignInVM } from "./SignInForm";
import { Button, Divider, Stack } from "@mui/joy";
import { useTranslation } from "../../i18n";
import { accessTokenManager } from "../../models/AccessTokenManager";
import { useNavigate } from "react-router-dom";
import GoogleIcon from "./GoogleIcon";

export default function SignIn() {
  const vm = React.useMemo(() => new SignInVM(), []);
  const navigate = useNavigate();

  const tokenClientRef = React.useRef(null);

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      // @ts-ignore
      tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
        client_id:
          "189305369344-udhmccd50j50ii2knrcvb33j4ksohgi1.apps.googleusercontent.com",
        scope: "email profile",
        callback: async (response: any) => {
          console.log("Google OAuth Response:", response);
          // Send response.access_token or ID token to backend
          const res = await accessTokenManager.signInWithGoogle(
            response.access_token,
            true
          );
          if (res) {
            navigate("/");
          }
        },
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [navigate]);

  const t = useTranslation();
  function handleGoogleAuth() {
    if (tokenClientRef.current) {
      // @ts-ignore
      tokenClientRef.current.requestAccessToken({ prompt: "consent" });
    }
  }

  return (
    <>
      <Stack gap={4} sx={{ mb: 2 }}>
        <Stack gap={1}>
          <Typography component="h1" level="h3">
            {t("Sign in")}
          </Typography>
          <Typography level="body-sm">
            {t("New to company?")}{" "}
            <Link href="/auth/sign-up" level="title-sm">
              {t("Sign up!")}
            </Link>
          </Typography>
        </Stack>
        <Button
          variant="soft"
          color="neutral"
          fullWidth
          startDecorator={<GoogleIcon />}
          onClick={handleGoogleAuth}
        >
          {t("Continue with Google")}
        </Button>
      </Stack>
      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector("light")]: {
            color: { xs: "#FFF", md: "text.tertiary" },
          },
        })}
      >
        or
      </Divider>
      <Stack gap={4} sx={{ mt: 2 }}>
        <SignInForm vm={vm} />
      </Stack>
    </>
  );
}
